import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
	name: "campaignmanagement",
	defaultRoutePath: "/campaigns/campaignmanagement",
	menuItemScope: "campaign",
	menuItemName: "campaignManagements",

    routes: [
        {
            path: "/campaigns/campaignmanagement",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "operatorAssociation",
            Component: Wizards.OperatorAssociation,
        },
        {
            path: "campaignactivitycreate",
            Component: Wizards.CampaignActivityCreate,
        },
    ],

}

export default Module;
